import type { QueryClient } from '@tanstack/react-query';

/**
 * Handles a 401 UNAUTHENTICATED response: drops every cached query, since the cache belongs to the account that
 * is no longer signed in, and sends the user to /login with the current location as `next`.
 */
export function redirectToLogin(
  queryClient: QueryClient,
  location: { pathname: string; search: string },
  navigate: (to: string) => void,
): void {
  queryClient.clear();
  const { pathname, search } = location;
  if (pathname.startsWith('/login') || pathname.startsWith('/register')) return;
  const next = `${pathname}${search}`;
  navigate(next === '/' ? '/login' : `/login?next=${encodeURIComponent(next)}`);
}
